import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IPayment } from '../interfaces/ipayment';
import { DatastoreService } from './datastore.service';
import { CommonFunctionsService } from './common-functions.service';
import { ApiService } from './api.service';
import moment from 'moment-timezone';
import { ParamMap } from '@angular/router';
import { interval } from 'rxjs';
import { lineOutstanding } from './payment-lines.util';
import { buildReturnUrl } from './return-url.util';

@Injectable({
  providedIn: 'root'
})
export class HeycentricService implements IPayment {

  constructor(
    private dataStore: DatastoreService,
    private http: HttpClient,
    private commonFunctionService: CommonFunctionsService,
    private apiService: ApiService
  ) {
    this.path = `/${this.commonFunctionService.getCompanyName()}/${this.commonFunctionService.getCompanyId()}/`;
  }
  config: any;
  url = 'https://staging.bookinglab.co.uk';
  readonly path;
  private heyCentricUrlPath = (window.location.hostname.indexOf('staging') !== -1) ? '/payment/' : '/payment/';
  readonly paymentType = 'heycentric';

  test() {
    throw new Error('Method not implemented.');
  }
  async invoke(companyId: number, bookingId: number, purchaseId: number, clientId: number, description: any, fundCode: any, reference: any, price: any, vatOptOut: any, feeItems?: any[]) {
    this.config = JSON.parse(this.dataStore.config);
    console.log('config', this.config);

    let booking = this.dataStore.booking;
    if (!booking) {
      const bookingStr = localStorage.getItem('ceremony');
      if (bookingStr) {
        booking = JSON.parse(bookingStr);
      }
    }
    console.log('booking', booking);

    const returnUrl = buildReturnUrl(`${this.path}verify/heycentric?bpc=${bookingId}|${purchaseId}|${companyId}`);

    // if no feeItems provided, wrap the single payment as a one-item array
    const items = (feeItems && feeItems.length > 0)
      ? feeItems
      : [{ pmtTyp: fundCode, data: { item: description, cost: price / 100, quantity: 1, paid: 0 } }];

    const body = {
      host: `${this.config.host}`,
      child_company: `${companyId}`,
      client_id: `${clientId}`,
      booking_ids: items.map(() => bookingId),
      purchase_id: purchaseId,
      purchase_long_id: `${booking.purchase_ref}`,
      rev_codes: items.map(f => f.pmtTyp),
      descriptions: items.map(f => f.data?.item),
      // Each line is charged only its unpaid remainder (cost×qty − paid).
      // Links without a paid stamp coerce to 0, so their full cost is charged.
      amounts: items.map(f => lineOutstanding(f.data)),
      return_url: returnUrl,
    };
    console.log('heycentric body', body);

    return this.http.post(`${this.url}${this.heyCentricUrlPath}hey-centric`, body).toPromise();
  }
  async verify(companyId: number, serviceId: number, bookingId: number, purchaseId: number, memberId: number, paymentRef: any, paymentType: string, queryString: ParamMap) {
    // now verify the payment
    console.log('queryString', queryString);
    const purchase: any = await this.apiService.getPurchase(companyId, serviceId, purchaseId);
    if (queryString.has('AuthCode') && queryString.has('Rc') && queryString.has('RecNo') && queryString.has('Pmt')) {
      const authCode = queryString.get('AuthCode');
      const rc = queryString.get('Rc');
      const recNo = queryString.get('RecNo');
      const pmt = queryString.get('Pmt');
      if (rc === 'A') {
        let extraItem: any = false;
        let extraItemLink: any = false;
        const extraItemLinkStr = localStorage.getItem('extraItemLink');
        if (extraItemLinkStr && extraItemLinkStr.length > 0) {
          extraItemLink = JSON.parse(extraItemLinkStr) as any;
        }
        const extraItemStr = localStorage.getItem('extraItem');
        if (extraItemStr && extraItemStr.length > 0) {
          extraItem = JSON.parse(extraItemStr) as any;
        }
        let paymentTypeStr = '';
        switch (paymentType) {
          case "installments":
            paymentTypeStr = 'Ceremony Fee Installment';
            break;
          case 'extra_items':
            paymentTypeStr = 'Optional extra';
            console.log(extraItem);
            if (extraItem) {
              paymentTypeStr = `${paymentTypeStr} (${extraItem.item_name}) Payment in Full`;
            }
            break;
          default:
            paymentTypeStr = 'Ceremony Fee Outstanding Balance';
        }
        const amount = parseFloat(pmt);

        if (paymentType === 'extra_items') {
          await this.apiService.updateBooking({
            price: (parseInt(purchase.price) + (amount * 100))
          }, companyId, bookingId, false);
        }
        // NOTE: as of the webhook-based payment-verify refactor on develop,
        // this verify() method is no longer called from the app. Payment
        // records are now created by the HeyCentric proxy as a webhook, and
        // add-ons / reschedule follow-up work runs inside
        // payment-verify.component on poll success. The body below is kept
        // only to satisfy the IPayment interface and the legacy
        // installments / extra_items branches.

        // add the payment to the pay API
        const paidPurchase = await this.apiService.payPurchase(companyId, serviceId, purchaseId, {
          amount: amount,
          transaction_id: `${recNo}`,
          notify: false,
          notify_admin: false,
          payment_status: 'paid',
          notes: `${paymentTypeStr}`
        });

        // add extra item
        if (paymentType === 'extra_items') {
          if (extraItemLink.item_id) {
            await this.apiService.linkExtraItem(companyId, serviceId, bookingId, extraItemLink.item_id, extraItemLink.data);
          }
        }
        return paidPurchase;
      }
    }
  }

  async preBasketFind(companyId, basketId, serviceItemId) {
    const body = {
      host: `${this.config.host}`,
      company_id: `${companyId}`,
      child_company: `${companyId}`,
      basket: `${basketId}`,
      service_item: `${serviceItemId}`,
    };
    return this.http.post(`${this.url}${this.heyCentricUrlPath}hey-centric/pre-basket/find`, body).toPromise();
  }
}
